export default "__VITE_ASSET__CejO3ldY__"